import { render, staticRenderFns } from "./selectPeople.vue?vue&type=template&id=8c520c1c&"
import script from "./selectPeople.vue?vue&type=script&lang=js&"
export * from "./selectPeople.vue?vue&type=script&lang=js&"
import style0 from "./selectPeople.vue?vue&type=style&index=0&id=8c520c1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports